{
  "point": "ponto",
  "points": "pontos",
  "credits": "créditos",
  "loyaltyCredit": "Crédito de fidelidade",
  "statusPoints": "Pontos de status",
  "balancePoints": "Pontos para gastar",
  "edit": "Editar",
  "delete": "Excluir",
  "copyOf": "Cópia de {value}",
  "numberedCopyOf": "Copiar de {index} do {value}",
  "total": "total",
  "uplift": "acréscimo",
  "approveBtn.label": "Ok",
  "cancelBtn.label": "Cancelar",
  "createBtn.label": "Criar",
  "saveBtn.label": "Salvar",
  "searchBtn.label": "Pesquisar",
  "updateBtn.label": "Atualizar",
  "applyBtn.label": "Aplicar",
  "addNewPlanBtn.label": "Adicionar plano",
  "launchPlanBtn.label": "Iniciar plano",
  "toOverviewBtn.label": "Ir para visão geral",
  "collapseBtn.label": "Recolher",
  "extendBtn.label": "Detalhes ",
  "updateAndSave.label": "Atualizar e salvar",
  "pleaseConfirmBtn.label": "Confirmar",
  "closeBtn.label": "Fechar",
  "resetBtn.label": "Redefinir",
  "confirmBtn.label": "Confirmar",
  "status.inactive": "Inativo",
  "status.active": "Ativo",
  "status.deactivated": "Desativado",
  "status.scheduled": "Agendado",
  "status.expired": "Vencido",
  "status.readyToUse": "Pronto para uso",
  "status.readyToLaunch": "Pronto para lançamento",
  "status.empty": "Vazio",
  "status.activity.pending": "Pendente",
  "status.activity.confirmed": "Confirmado",
  "status.activity.expired": "Vencido",
  "status.activity.canceled": "Cancelado",
  "status.activity.removed": "Removido",
  "status.default": "Padrão",
  "action.promotion": "Promoção",
  "action.referral": "Indicação",
  "action.action": "Ação",
  "tiers.numberOfPurchases.plural.zero": "{number} compras",
  "tiers.numberOfPurchases.plural.one": "{number} compra",
  "tiers.numberOfPurchases.plural.two": "{number} compras",
  "tiers.numberOfPurchases.plural.few": "{number} compras",
  "tiers.numberOfPurchases.plural.many": "{number} compras",
  "tiers.numberOfPurchases.plural.other": "{number} compras",
  "validity.unlimited": "Ilimitado",
  "validity.limitedFromEarn.value.days.plural.zero": "{number} dias",
  "validity.limitedFromEarn.value.days.plural.one": "{number} dia",
  "validity.limitedFromEarn.value.days.plural.two": "{number} dias",
  "validity.limitedFromEarn.value.days.plural.few": "{number} dias",
  "validity.limitedFromEarn.value.days.plural.many": "{number} dias",
  "validity.limitedFromEarn.value.days.plural.other": "{number} dias",
  "validity.limitedFromEarn.value.weeks.plural.zero": "{number} semanas",
  "validity.limitedFromEarn.value.weeks.plural.one": "{number} semana",
  "validity.limitedFromEarn.value.weeks.plural.two": "{number} semanas",
  "validity.limitedFromEarn.value.weeks.plural.few": "{number} semanas",
  "validity.limitedFromEarn.value.weeks.plural.many": "{number} semanas",
  "validity.limitedFromEarn.value.weeks.plural.other": "{number} semanas",
  "validity.limitedFromEarn.value.months.plural.zero": "{number} meses",
  "validity.limitedFromEarn.value.months.plural.one": "{number} mês",
  "validity.limitedFromEarn.value.months.plural.two": "{number} meses",
  "validity.limitedFromEarn.value.months.plural.few": "{number} meses",
  "validity.limitedFromEarn.value.months.plural.many": "{number} meses",
  "validity.limitedFromEarn.value.months.plural.other": "{number} meses",
  "days": "Dias",
  "dayInMonth": "Dia",
  "month": "Mês",
  "months.1": "Janeiro",
  "months.2": "Fevereiro",
  "months.3": "Março",
  "months.4": "Abril",
  "months.5": "Maio",
  "months.6": "Junho",
  "months.7": "Julho",
  "months.8": "Agosto",
  "months.9": "Setembro",
  "months.10": "Outubro",
  "months.11": "Novembro",
  "months.12": "Dezembro",
  "form.missingSettingsAlert": "Certifique-se de inserir todas as informações necessárias antes de salvar e prosseguir para a próxima etapa.",
  "noResults.title": "Nenhum resultado encontrado.",
  "noResults.text": "Não há resultados correspondentes para sua pesquisa de \"{text}\".",
  "alertContainer.editModeAlert.message": "Você está editando a próxima versão do seu plano de fidelidade. Suas alterações entram em vigor após você iniciar esta nova versão. ",
  "alertContainer.liveModeAlert.message.linkText": "Saiba mais",
  "alertContainer.liveModeAlert.message": "Para editar níveis, benefícios fixos e adicionais, em Gerenciamento de fidelidade, selecione Atualizar e iniciar e, depois, alterne para Editar próxima versão. {link}",
  "card.isRoadmap.text": "Roadmap",
  "catalogSelector.tooManyResults.title": "Há muitos resultados para esta pesquisa. ",
  "catalogSelector.tooManyResults.text": "Tente fazer uma pesquisa novamente com palavras-chave mais específicas para restringir seus resultados.",
  "catalogSelector.errorAlert": "Algo deu errado. Tente novamente.",
  "catalogSelector.searchPlaceholder.byItem": "Pesquise um produto específico.",
  "catalogSelector.searchPlaceholder.byCatOrBrand": "Selecione marcas ou categorias específicas que você deseja promover.",
  "catalogSelector.checkAllItems.label": "Selecionar todos",
  "catalogSelector.showAllSelections.label": "Mostrar apenas os itens selecionados.",
  "catalogSelector.cancelBtn.label": "Fechar",
  "catalogSelector.saveBtn.label": "Aplicar e salvar",
  "catalogSelector.brands.plural.zero": "{number} marcas",
  "catalogSelector.brands.plural.one": "{number} marca",
  "catalogSelector.brands.plural.two": "{number} marcas",
  "catalogSelector.brands.plural.few": "{number} marcas",
  "catalogSelector.brands.plural.many": "{number} marcas",
  "catalogSelector.brands.plural.other": "{number} marcas",
  "catalogSelector.category.plural.zero": "{number} categorias",
  "catalogSelector.category.plural.one": "{number} categoria",
  "catalogSelector.category.plural.two": "{number} categorias",
  "catalogSelector.category.plural.few": "{number} categorias",
  "catalogSelector.category.plural.many": "{number} categorias",
  "catalogSelector.category.plural.other": "{number} categorias",
  "catalogSelector.product.plural.zero": "{number} produtos",
  "catalogSelector.product.plural.one": "{number} produto",
  "catalogSelector.product.plural.two": "{number} produtos",
  "catalogSelector.product.plural.few": "{number} produtos",
  "catalogSelector.product.plural.many": "{number} produtos",
  "catalogSelector.product.plural.other": "{number} produtos",
  "confirmNavDialog.discardChanges.text": "Certifique-se de salvar as alterações. Se você sair desta página, qualquer alteração não salva será perdida.",
  "confirmNavDialog.approveBtn.label": "OK",
  "confirmNavDialog.cancelBtn.label": "Cancelar",
  "actionDashboard.overviewLinkText.referral": "Ir para Ações de indicação",
  "actionDashboard.editLinkText": "Editar programa",
  "dashboardOptions.launchedAt": "Programa iniciado em: ",
  "dashboardOptions.currentlyShowingLabel": "Exibindo atualmente:",
  "dashboardOptions.viewLabel": "Visualizar:",
  "masterActions.join.largeText": "Participar do programa de fidelidade",
  "masterActions.purchases.largeText": "Compra",
  "status.inactive.tooltip": "As configurações não foram concluídas.",
  "status.inactive.tooltip.proomotionEnded": "Esta promoção está inativa e não pode ser editada. Você pode copiar a promoção ou criar uma nova.",
  "status.inactive.tooltip.connectedToRewardPools": "O conjunto de vouchers {name} tem o status {status}.",
  "status.inactive.tooltip.invalidPromotionRecurringDates": "Confira as datas da promoção.",
  "status.readyToUse.tooltip.promotion": "A promoção está pronta para uso. Você pode exibir automaticamente a promoção na carteira do membro ou anexar aos membros no Editor de campanha usando tokens de fidelidade.",
  "status.readyToUse.tooltip.attachable": "A ação está pronta para uso e pode ser anexada aos contatos por meio do editor de campanha usando os tokens de fidelidade.",
  "status.active.tooltip.promotion": "Esta promoção está ativa e disponível para seus membros.",
  "status.active.tooltip.attachable": "Esta ação está ativa. Você não pode alterar as configurações. Para editar esta ação, primeiro desative-a e aguarde a data de expiração especificada. Você também pode copiar a ação, editar a cópia e iniciar a cópia como uma nova ação.",
  "status.active.tooltip.event": "Esta ação está ativa. Você pode conectar a ação a benefícios ou programa de automação.",
  "status.deactivated.tooltip.promotion": "Você desativou esta promoção e ela não está mais disponível para membros.",
  "status.deactivated.tooltip.attachable": "Você desativou esta ação. Para editar ou excluir esta ação, você tem que esperar pela data de expiração especificada. Você também pode copiar a ação, editar a cópia e iniciar a cópia como uma nova ação.",
  "editorTypePopup.title": "Selecione o tipo de editor",
  "editorTypePopup.text": "Clientes sem acesso exclusivo verão uma página de bloqueio. Você pode criar uma página HTML personalizada ou usar um dos nossos modelos.",
  "editorTypePopup.options.html.text": "Criar página HTML personalizada",
  "editorTypePopup.options.template.text": "Criar página a partir de um modelo",
  "fileInputField.uploadBtn.label": "Carregar",
  "fileInputField.browseBtn.label": "Navegar",
  "formStepsContainer.nextStep.text": "Próxima etapa",
  "formStepsContainer.prevStep.text": "Etapa anterior",
  "iconGallery.title": "Galeria de ícones de fidelidade",
  "iconGallery.deleteDialog.headline": "Tem certeza de que deseja excluir este ícone?",
  "iconGallery.deleteDialog.content": "Após excluir este ícone, ele não ficará visível para os membros. Certifique-se de que este ícone não esteja conectado a nenhuma ação ou voucher.",
  "iconGallery.uploadResult.successMessage": "Upload bem-sucedido.",
  "iconGallery.searchInput.placeholder": "Pesquisar o ícone pelo nome.",
  "iconGallery.fileUploader.tooltip": "<h3>Carregar</h3><b>Requisitos de upload de ícone:</b></br>Arquivo: SVG ou PNG</br>Formato: quadrado<br>Dimensões máximas: 200x200 pixels <br>Tamanho máx. de arquivo: 100 KB</br><sub>* Recomendamos um plano de fundo transparente </sub>.",
  "multiLangPopup.defaultNoticeText": "O idioma principal definido por você é o idioma padrão que os membros veem, caso não haja configurações de idioma adequadas.",
  "multiLangPopup.defaultTitle.currency": "Conversão de moeda",
  "multiLangPopup.defaultTitle.language": "Tradução de idioma",
  "multiMarketSelector.multiSelectField.placeholder": "-- Selecionar mercados --",
  "multiMarketSelector.selectField.placeholder": "-- Selecionar mercado --",
  "multiPlanSelect.label": "Selecione seu plano de fidelidade ",
  "preLaunchPopup.conditions.plan.title": "Configurações do plano",
  "preLaunchPopup.conditions.plan.text": "Verifique as configurações do seu plano de fidelidade para garantir que tudo esteja configurado corretamente e corresponda aos termos para membros.",
  "preLaunchPopup.conditions.tiers.title": "Níveis e benefícios",
  "preLaunchPopup.conditions.tiers.text": "Verifique se os níveis estão configurados corretamente para todos os seus membros e se a distribuição de contatos nos níveis corresponde à sua estratégia.",
  "preLaunchPopup.conditions.rewards.title": "Conjuntos de recompensas",
  "preLaunchPopup.conditions.rewards.text": "Verifique se você carregou códigos de vouchers suficientes para todas as respostas e se todos os conjuntos e a validade dos vouchers estão definidos corretamente.",
  "preLaunchPopup.conditions.actions.title": "Ações",
  "preLaunchPopup.conditions.actions.text": "Verifique se suas ações abrangem todas as táticas que você deseja usar e se você ativou todas as ações padrão.",
  "preLaunchPopup.title": "Tem certeza de que deseja iniciar seu plano de fidelidade?",
  "preLaunchPopup.text": "Verifique suas configurações para ter certeza de que seu plano de fidelidade está pronto para ser lançado:",
  "timeValidityInput.radioLabel.days": "Dias",
  "timeValidityInput.radioLabel.weeks": "Semanas",
  "timeValidityInput.radioLabel.months": "Meses",
  "ctaUrl": "URL do CTA",
  "ctaText": "Texto do CTA",
  "message": "Mensagem",
  "pageNotFound": "Não conseguimos encontrar a página que você está procurando.",
  "externalEventSetup.title": "Evento de fidelidade externo",
  "externalEventSetup.name.label": "Nome do evento externo",
  "externalEventSetup.description.label": "Descrição4",
  "externalEventSetup.description.tooltip": "Uma descrição é interna e ajuda você a gerenciar seus eventos de fidelidade.",
  "pointsRatesFields.perDescriptor.points": "ganho por",
  "catalog.item.type.category.name": "Categoria",
  "catalog.item.type.brand.name": "Marca",
  "catalog.item.type.item.name": "Produto",
  "catalog.item.type.itemId.name": "ID do item",
  "exclusiveAccessOffers.options.fixedBenefit.title": "Acesso como benefício fixo",
  "exclusiveAccessOffers.options.additionalBenefits.title": "Acesso como um benefício adicional",
  "exclusiveAccessOffers.options.action.title": "Acesso como uma recompensa de ação",
  "exclusiveAccessOffers.options.redemption.title": "Acesso por pontos",
  "exclusiveAccessOffers.options.redemptionForFree.title": "Acesso gratuito",
  "accessValidityType.options.unlimited.name": "O acesso é válido por um período ilimitado.",
  "accessValidityType.options.limitedFromEarn.name": "O acesso é válido por um período limitado, a partir do momento em que o membro o obtém.",
  "accessValidityType.options.fixedDate.name": "O acesso é válido por um período predefinido para todos os membros.",
  "accessValidityType.options.disabled.fixedBenefit.name": "Desabilite a disponibilidade de acesso como um benefício fixo.",
  "accessValidityType.options.disabled.additionalBenefit.name": "Desabilite a disponibilidade de acesso como um benefício adicional.",
  "accessValidityType.options.disabled.reward.name": "Desabilite a disponibilidade de acesso como recompensa por ações.",
  "createOfModify.options.create.name": "Ativar oferta",
  "createOfModify.options.create.tooltip": "Quando você ativa uma nova oferta, as regras da oferta ativa são redefinidas e ficam disponíveis para membros de todos os níveis selecionados pelo período de oferta definido.",
  "createOfModify.options.create.tooltip2": "Quando você ativa uma nova oferta, as restrições da oferta ativa são redefinidas e ficam disponíveis para membros de todos os níveis selecionados pelo período de oferta definido. ",
  "createOfModify.options.modify.name": "Editar oferta ativa",
  "createOfModify.options.modify.tooltip": "Ao editar uma oferta ativa, suas alterações não afetam os membros que já resgataram essa oferta.",
  "exclusiveAccessFormSteps.exclusiveAccessPoolSettings.title": "Configurações de exclusividade",
  "exclusiveAccessFormSteps.exclusiveAccessBlockingEditor.title": "Página de bloqueio",
  "exclusiveAccessFormSteps.redemptionValue.title": "Acesso e ofertas",
  "exclusiveAccessFormSteps.EXCLUSIVE_ACCESS_VALIDITY.title": "Ativação",
  "activityElementPointsText.loyalty": "{{points_name}}",
  "activityElementPointsText.pointsToSpend": "{{points_name}} para gastar",
  "activityElementPointsText.status": "Status {{points_name}}",
  "activityElementPointsText.cashback": "Cashback",
  "activityElementPointsText.cashback.name": "{{cashback_name}}",
  "voucherTypeText.one_time": "Voucher de uso único",
  "voucherTypeText.yearly": "Voucher de utilização múltipla",
  "exclusiveAccessTypeText.permanent": "Acesso exclusivo permanente",
  "exclusiveAccessTypeText.limitedTerm": "Acesso exclusivo por tempo limitado",
  "mainTabs.dashboard.title": "Painel",
  "mainTabs.actions.title": "Ações",
  "mainTabs.rewards.title": "Recompensas",
  "mainTabs.tiers.title": "Níveis",
  "mainTabs.loyaltyWallet.title": "Carteira de fidelidade",
  "mainTabs.memberProfiles.title": "Perfis dos membros",
  "mainTabs.externalEvents.title": "Eventos externos",
  "mainTabs.planSettings.title": "Configurações do plano",
  "mainTabs.vouchers.title": "Vouchers",
  "mainTabs.exclusiveAccesss.title": "Acesso exclusivo",
  "mainTabs.loyaltyManagement.title": "Gerenciamento de fidelidade",
  "mainTabs.security.title": "Configurações de fidelidade",
  "actionTabs.purchases.title": "Compras",
  "actionTabs.promotions.title": "Promoções",
  "actionTabs.engagements.title": "Engajamento",
  "actionTabs.events.title": "Eventos",
  "actionTabs.referral.title": "Indicação",
  "actionTabs.join.title": "Participar do programa de fidelidade",
  "tierTabs.tiers.title": "Níveis",
  "tierTabs.fixedBenefits.title": "Benefícios fixos",
  "tierTabs.additionalBenefits.title": "Benefícios adicionais",
  "tierTabs.contactDistribution.title": "Gráfico de distribuição",
  "managementTabs.accountSettings.title": "Configurações da conta",
  "managementTabs.languageAndCurrency.title": "Idioma e moeda",
  "managementTabs.planSettings.title": "Configurações do plano",
  "managementTabs.cashbackSettings.title": "Configurações de cashback",
  "managementTabs.membershipSettings.title": "Configurações de afiliação",
  "managementTabs.updateAndLaunch.title": "Atualizar e iniciar",
  "onboardingTabs.accountSettings.title": "Criação de plano",
  "onboardingTabs.activation.title": "Ativação",
  "customerCalcPeriod.options.1.name": "Últimos 30 dias",
  "customerCalcPeriod.options.2.name": "Últimos 60 dias",
  "customerCalcPeriod.options.3.name": "Últimos 90 dias",
  "customerCalcPeriod.options.6.name": "Últimos 6 meses",
  "customerCalcPeriod.options.12.name": "Últimos 12 meses",
  "planType.options.points.name": "Pontos e resgate",
  "planType.options.points_and_benefits.name": "Pontos e benefícios",
  "planType.options.spend.name": "Gastos e benefícios",
  "planType.options.points.tooltip": "Plano baseado em pontos com níveis únicos ou múltiplos e resgate de pontos.",
  "planType.options.points_and_benefits.tooltip": "Plano baseado em pontos com múltiplos níveis e benefícios sem resgate de pontos.",
  "planType.options.spend.tooltip": "Plano baseado em gastos com níveis únicos ou múltiplos e benefícios sem pontos, mas com regras de opção de cashback. Apenas uma moeda é gerenciada em um plano baseado em gastos. Se você gerencia várias moedas, precisa gerenciar um plano separado para cada moeda.",
  "pointsAllocatopmDelay.options.1.name": "24 horas",
  "pointsAllocatopmDelay.options.2.name": "48 horas",
  "pointsAllocatopmDelay.options.3.name": "72 horas",
  "pointsAllocatopmDelay.options.7.name": "7 dias",
  "pointsAllocatopmDelay.options.14.name": "14 dias",
  "pointsAllocatopmDelay.options.21.name": "21 dias",
  "pointsAllocatopmDelay.options.30.name": "30 dias",
  "pointsAllocatopmDelay.options.40.name": "40 dias",
  "tierCalculationType.options.endOfYear.name": " O cálculo de níveis ocorre em 31 de dezembro a cada [X anos].",
  "tierCalculationType.options.endOfYear.tooltip": "Os níveis são calculados em uma data fixa, a cada [x anos]. Os membros que passam por upgrade para um nível mais alto mantêm seu status de nível pelo período definido.",
  "tierCalculationType.options.afterJoin.name": "O cálculo de nível é feito [X meses] a partir da data em que o membro entra em um nível.",
  "tierCalculationType.options.afterJoin.tooltip": "A data de cálculo de nível pode variar dependendo do progresso do membro pelos níveis. Os membros que passam por upgrade para um nível mais alto mantêm seu status de nível pelo menos pelo período definido.",
  "tierCalculationType.options.endOfYear.spend.tooltip": "Quando o nível é calculado, o crédito de fidelidade é redefinido, mas os membros mantêm seu status de nível até o próximo cálculo.",
  "tierCalculationType.options.noDropout.name": "Os níveis não são calculados. Os membros não precisam atender aos requisitos para permanecer neste nível.",
  "tierCalculationType.options.noDropout.tooltip": "Os pontos são coletados apenas para upgrade de nível.",
  "statusPointsExpirationType.options.tierCalc.name": "Os pontos de status expiram e são redefinidos na data de cálculo de nível.",
  "statusPointsExpirationType.options.tierCalc.tooltip": "Quando os pontos são calculados, eles são redefinidos, mas os membros mantêm seu status de nível até o próximo cálculo.",
  "statusPointsExpirationType.options.fromEarn.name": "Os pontos de status expiram e são redefinidos a cada [X meses] a partir da data em que o membro os ganha.",
  "statusPointsExpirationType.options.fromEarn.tooltip": "Quando os níveis são calculados, apenas os pontos válidos para aquele dia são calculados. Os membros mantêm seus status ou caem para um nível mais baixo.",
  "statusPointsExpirationType.options.never.name": "Os pontos de status nunca expiram.",
  "loyaltyCreditExpirationType.options.tiersCalc.name": "O crédito de fidelidade expira e é redefinido na data em que os níveis são calculados.",
  "loyaltyCreditExpirationType.options.tiersCalc.tooltip": "Quando o crédito de fidelidade é calculado, ele é redefinido, mas os membros mantêm seu status de nível até o próximo cálculo.",
  "loyaltyCreditExpirationType.options.fromEarn.name": "O crédito de fidelidade expira e é redefinido a cada [X meses] a partir da data em que o membro ganha o crédito.",
  "loyaltyCreditExpirationType.options.fromEarn.tooltip": "Quando os níveis são calculados, apenas o crédito de fidelidade válido para aquele dia é calculado. Os membros mantêm seus status ou caem para um nível mais baixo.",
  "optIn.options.invitation.name": "Todos os contatos são convidados a aderir ao plano de fidelidade.",
  "optIn.options.automatic.name": "Todos os contatos se tornam automaticamente membros do programa de fidelidade.",
  "historicalBalancePoints.options.keep.name": "Recompensar com pontos de gastos.",
  "historicalBalancePoints.options.keep.tooltip": "Esta opção incentiva os membros a resgatar pontos em troca de recompensas.",
  "historicalBalancePoints.options.remove.name": "Não recompensar com pontos de gastos.",
  "historicalBalancePoints.options.remove.tooltip": "Os pontos de gastos são redefinidos e os membros devem ganhar novos pontos para realizar resgates.",
  "currencyIdentifierSigh.options.symbol.name": "Símbolo da moeda",
  "currencyIdentifierSigh.options.symbol.tooltip": "Exemplo: $500",
  "currencyIdentifierSigh.options.code.name": "Código de moeda ISO",
  "currencyIdentifierSigh.options.code.tooltip": "Exemplo: 500USD",
  "currencyIdentifierSigh.options.none.name": "Sem identificador",
  "formStepRewards.options.poolSettings.title": "Configuração do conjunto",
  "formStepRewards.options.uploadFile.title": "Carregar arquivo",
  "formStepRewards.options.redemptionValue.title": "Configurações da oferta",
  "formStepRewards.options.validity.title": "Validade",
  "specialTiers.redemptopmSettings.all.name": "Usar as mesmas configurações para todos os níveis. Valores de nível individuais são substituídos.",
  "voucherValidityType.options.unlimited.name": "O voucher é válido por um período ilimitado.",
  "voucherValidityType.options.limitedFromEarn.name": "O voucher é válido por um período limitado a partir do momento em que o membro o ganha.",
  "voucherValidityType.options.fixedDate.name": "O voucher é válido por um período predefinido para todos os membros.",
  "redemptionLimit.options.noLimit.name": "Mostrar esta oferta automaticamente aos membros regularmente.",
  "redemptionLimit.options.noLimit.tooltip": "Se você habilitar o comutador para um nível, a oferta de resgate será exibida na carteira de fidelidade sem restrições de resgate.",
  "redemptionLimit.options.limitMember.name": "Selecione quantas vezes cada membro pode resgatar um voucher durante o período definido para esta oferta.",
  "exclusiveAccessExclusivityType.options.name.fixed": "Exclusividade permanente",
  "exclusiveAccessExclusivityType.options.name.limitedTerm": "Exclusividade por prazo limitado",
  "exclusiveAccessExclusivityType.options.name.limited": "Exclusividade limitada",
  "editorContentTextDefaultValues.tag": "Acesso exclusivo",
  "editorContentTextDefaultValues.firstHeader": "<strong>Black Friday antecipada</strong>",
  "editorContentTextDefaultValues.secondHeader": "<strong>LIQUIDAÇÃO</strong>",
  "editorContentTextDefaultValues.middleText": "Ofertas exclusivas de Black Friday para nossos membros fiéis. Não perca. Participe do plano de fidelidade!",
  "editorContentTextDefaultValues.actionTopText": "Ainda não é membro? Junte-se ao nosso plano de fidelidade e comece a ganhar recompensas.",
  "editorContentTextDefaultValues.leftButton": "Participar do programa de fidelidade",
  "editorContentTextDefaultValues.rightButton": "Outra hora",
  "editorContentTextDefaultValues.actionBottomText": "<span>Já é um membro? <u>Faça login</u></span>",
  "editorContentTextDefaultValues.middleText.mobile": "Ofertas exclusivas para nossos clientes fiéis. Não perca. Junte-se ao nosso plano de fidelidade!",
  "editorContentTextDefaultValues.actionTopText.mobile": "Ainda não é membro? Junte-se ao nosso programa de fidelidade.",
  "accessUrlType.options.exactUrl.name": "Bloqueie e ofereça acesso exclusivo a esta página:",
  "accessUrlType.options.startsWithUrl.name": "Bloqueie e ofereça acesso exclusivo a todas as páginas que começam com este URL:",
  "formStepsContainer.tierSettings.title": "Configurações de níveis",
  "formStepsContainer.purchaseBenefits.title": "Comprar benefícios",
  "formStepsContainer.visibility.title": "Visibilidade",
  "tierDropout.options.yes.name": "Sim, esse nível é calculado e os membros devem atender aos requisitos para permanecer nele.",
  "tierDropout.options.no.name": "Não, não há cenário de rebaixamento para este nível.",
  "fixedBenfitType.options.oneTimeVoucher.name": "Voucher único",
  "fixedBenfitType.options.fixedYearlyVoucher.name": "Voucher anual fixo (é necessário um código de utilização múltipla).",
  "fixedBenfitType.options.eventAction.name": "Evento",
  "fixedBenfitType.options.exclusiveAccess.name": "Acesso exclusivo",
  "fixedBenfitType.options.custom.name": "Personalizado (fornecido independentemente por você)",
  "fixedBenfitType.options.fixedYearlyVoucher.additional.name": "Voucher de utilização múltipla (é necessário um código de utilização múltipla).",
  "tierTypeOptions.regular.name": "Baseado em pontos",
  "tierTypeOptions.invite.name": "Somente para convidados",
  "tierTypeOptions.invite.tooltip.learnMoreLinkText": "Saiba mais",
  "tierTypeOptions.invite.tooltip": "Somente membros convidados ou pagantes podem pertencer ao nível. Gerencie o pagamento e a afiliação do seu lado. Para adicionar um membro a este nível, use a API de fidelidade ou os perfis de membros. {learnMoreLink}.",
  "tierTypeOptions.spend.name": "Baseado em gastos",
  "exclusiveAccess.cardLabels.permanent": "Permanente",
  "exclusiveAccess.cardLabels.limtedTerm": "Por prazo limitado",
  "cards.filterBar.moreFiltersButton": "Mais filtros",
  "catalogSelector.selected.single": "{items} selecionado(s)",
  "catalogSelector.selected.multiple": "{items} e {lastItems} selecionado",
  "iconGallery.uploadResult.failMessage": "Ocorreu um erro ao carregar. Certifique-se de que os arquivos correspondam aos requisitos. \n{showFileList,select,true{{failed} de {total} com falha: {failedDetails}} other{{failedDetails}}} ",
  "pointsRatesFields.perDescriptor.spend": "para cada",
  "activityElementMultiuplyPointsText.double": "Duplo",
  "activityElementMultiuplyPointsText.triple": "Triplo"
}
